import layout from '@/layout/default.vue';

export default [{
  path: 'material',
  redirect: 'material/index',
  component: layout,
  children: [{
    path: 'index',
    meta: { title: '供应链首页' },
    component: () => import('@/views/supplier/material/index.vue')
  }]
}, {
  path: 'scheme',
  redirect: 'scheme/index',
  component: layout,
  children: [{
    path: 'index',
    meta: { title: '解决方案首页' },
    component: () => import('@/views/supplier/scheme/index.vue')
  }, {
    path: 'add',
    component: () => import('@/views/supplier/scheme/add.vue')
  }]
}, {
  path: 'myProduct',
  redirect: 'myProduct/list',
  component: layout,
  children: [{
    path: 'list',
    meta: { title: '我的产品' },
    component: () => import('@/views/supplier/myProduct/list.vue')
  }]
}, {
  path: 'inquiryParams',
  redirect: 'inquiryParams/list',
  component: layout,
  children: [{
    path: 'list',
    meta: { title: '询参数单' },
    component: () => import('@/views/supplier/inquiryParams/list.vue')
  }]
}, {
  path: 'inquiryPrice',
  redirect: 'inquiryPrice/list',
  component: layout,
  children: [{
    path: 'list',
    meta: { title: '询价格单' },
    component: () => import('@/views/supplier/inquiryPrice/list.vue')
  }]
}, {
  path: 'factoryReport',
  redirect: 'factoryReport/list',
  component: layout,
  children: [{
    path: 'list',
    meta: { title: '原厂报备' },
    component: () => import('@/views/supplier/factoryReport/list.vue')
  }]
}, {
  path: 'myContract',
  redirect: 'myContract/list',
  component: layout,
  children: [{
    path: 'list',
    meta: { title: '我的合同' },
    component: () => import('@/views/supplier/myContract/list.vue')
  }]
}, {
  path: 'promotion',
  redirect: 'promotion/list',
  component: layout,
  children: [{
    path: 'list',
    meta: { title: '我要申请推广' },
    component: () => import('@/views/supplier/promotion/list.vue')
  }]
}, {
  path: 'materialAuthManage',
  redirect: 'materialAuthManage/list',
  component: layout,
  children: [{
    path: 'list',
    meta: { title: '材料供应商认证管理' },
    component: () => import('@/views/supplier/materialAuthManage/list.vue')
  }]
}];
